export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13761.46d3a14f.jpg";